/**
 * Copyright (c) Granthika Co., All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 */
import firebase from "firebase/app"
import * as firebaseui from 'firebaseui'

// The Firebase configuration is injected during the build. The 'declare'
// line is necessary to make TypeScript happy and the follow 'var firebaseConfig'
// line will get the configuration object inject by the webpack DefinePlugin 
// (see vue.config.js )
declare var __FIREBASE_CONFIG__: object
var firebaseConfig = __FIREBASE_CONFIG__

console.log('firebase config', firebaseConfig)
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
// firebase.analytics()
let fireui:firebaseui.auth.AuthUI = new firebaseui.auth.AuthUI(firebase.auth())

class FirebaseClient {  
  
  ui() {
    return fireui
  }

  auth() {
    return firebase.auth()
  }

  isSignInWithEmailLink() {
    return this.auth().isSignInWithEmailLink(window.location.href)
  }
}  

export default new FirebaseClient()